import { Spin } from "../components/ui/spin";
export default Spin;